import React, {useCallback, useContext, useState} from 'react';
import {Link} from 'react-router-dom';

import {AuthContext, PageContext, refreshToken, toast} from "@lb/mlib-components";
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import {IconButton, Stack, Tooltip} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import logo from '../../pages/home/LongboardColourLogo.png';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import PageContextZiggy from "../../store/page-context-ziggy";
import ListItemIcon from '@mui/material/ListItemIcon';
import Logout from '@mui/icons-material/Logout';
import Divider from "@mui/material/Divider";
import Warehouses from "./Warehouses";
import {logout} from "../../libs/TokenHandler";
import MySearch from "./MySearch";
import RefreshIcon from "@mui/icons-material/Refresh";
import jwtDecode from "jwt-decode";
import Roles from "./Roles";
import {AutoFixHigh, HowToReg} from "@mui/icons-material";
import Loader from "../ui/Loader";

export function handleFixMyProblems() {
    window.location.reload()
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key.includes('PersistDataGridPro')) {
            localStorage.removeItem(key);
        }
    }
}

const Header = ({callLoad}) => {

    const pageCtxZiggy = useContext(PageContextZiggy);
    const pageCtx = useContext(PageContext);

    const pageTitle = pageCtx.title;
    const authCtx = useContext(AuthContext);
    const [openBackdrop, setOpenBackdrop] = useState(false);

    function handleChange() {
        handleClose()
    }

    const handleMenu = useCallback((event) => {
        setAnchorEl(event.currentTarget)
    }, [])

    const handleClose = useCallback(() => {
        setAnchorEl(null)
    }, [])

    const logoutHandler = useCallback(() => {
        setOpenBackdrop(true)

        logout(authCtx.accessToken).catch(error => error).finally(() => {
            handleClose()
            setOpenBackdrop(false)
            authCtx.clear()
            toast.success('Successfully logged out')
        })

    }, [authCtx, handleClose])

    const userName = authCtx.userName;
    const title = pageCtx.title;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);

    const getInitials = (name, maxLength = 3) => {

        const chars = [...name.trim()];

        if (name.length <= maxLength) return name;

        const initials = [];

        for (const [idx, char] of chars.entries()) {
            if (
                char.toLowerCase() !== char ||
                !chars[idx - 1] ||
                /\s/.test(chars[idx - 1])
            ) {
                initials.push(char);

                if (initials.length === maxLength) break;
            }
        }

        return initials.join('');
    };

    const {build} = window['runConfig'];

    let color;

    if (build === "Production")
        color = '#2a2f34'
    else
        color = '#37b6ff'

    function refresh() {
        callLoad()
    }

    const [openModal, setOpenModal] = useState(false);
    const [accessContent, setAccessContent] = useState([])

    const refreshTokens = useCallback(() => {
        setOpenBackdrop(true)

        refreshToken(authCtx.refreshToken).then(async (token) => {
            const accessTokenDecoded = jwtDecode(token.access_token)

            await authCtx.update(
                accessTokenDecoded.name,
                token.access_token,
                accessTokenDecoded.exp,
                token.refresh_token,
                token.refresh_token_exp,
                accessTokenDecoded.azp,
                {
                    realm_access: accessTokenDecoded.realm_access,
                    resource_access: accessTokenDecoded.resource_access
                }
            )

            setAccessContent(authCtx.readRoles())

            setOpenModal(true)
        }).finally(() => setOpenBackdrop(false))
    }, [authCtx])

    return (
        <AppBar style={{background: color}} position="fixed" sx={{zIndex: (theme) => theme.zIndex.drawer + 1}}>
            <Loader active={openBackdrop}/>
            <header style={{
                height: "4rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0% 1%"
            }}>
                <Stack direction={'row'} justifyContent={"center"} alignItems={"center"}>
                    <Link to='/'>
                        <img src={logo} alt={"Ziggy"} style={{width: "10rem"}}/>
                    </Link>

                    {authCtx.isLoggedIn() && <MySearch/>}
                </Stack>

                {authCtx.isLoggedIn() &&
                    <Stack direction={"row-reverse"} spacing={2} justifyContent={"center"} alignItems={"center"}>

                        {(pageTitle === "Shipping | Prepare" || pageTitle === "Shipping | Fulfilment" || pageTitle === "Production | Orders" || pageTitle === "Shipping | Scheduler") ?
                            <Typography
                                color="inherit" variant="h5"
                                component="div">
                                {title} ({pageCtxZiggy.warehouse.toLowerCase().charAt(0).toUpperCase() + pageCtxZiggy.warehouse.toLowerCase().slice(1)})
                            </Typography>
                            :
                            <Typography
                                color="inherit" variant="h5"
                                component="div">
                                {title}
                            </Typography>}
                    </Stack>
                }

                {authCtx.isLoggedIn() &&
                    <Stack direction={"row"} spacing={2} justifyContent={"center"} alignItems={"center"}>
                        {pageCtx.title && <Typography
                            edge="end"
                            variant="h6"
                            align="right"
                        >
                            <Tooltip title="Refresh">
                                <IconButton color="inherit" onClick={refresh}>
                                    <RefreshIcon fontSize={"large"}/>
                                </IconButton>
                            </Tooltip>
                        </Typography>}
                        <div>
                            <IconButton
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                            >
                                <Avatar>
                                    {getInitials(userName)}
                                </Avatar>
                                <Typography variant="subtitle1" sx={{
                                    color: "#FFFFFF",
                                    paddingLeft: "1rem"
                                }}>
                                    {userName}
                                </Typography>
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                keepMounted
                                open={open}
                                onClose={handleClose}
                            >
                                <Warehouses handleChange={handleChange}/>
                                <Divider/>

                                <MenuItem onClick={refreshTokens}>
                                    <ListItemIcon>
                                        <HowToReg fontSize="small"/>
                                    </ListItemIcon>
                                    Check Roles
                                </MenuItem>
                                <Divider/>
                                <MenuItem onClick={handleFixMyProblems}>
                                    <ListItemIcon>
                                        <AutoFixHigh fontSize="small"/>
                                    </ListItemIcon>
                                    Fix My Problems
                                </MenuItem>
                                <Divider/>
                                <MenuItem onClick={logoutHandler}>
                                    <ListItemIcon>
                                        <Logout fontSize="small"/>
                                    </ListItemIcon>
                                    Logout
                                </MenuItem>

                            </Menu>
                        </div>
                        <Roles
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                            roles={accessContent}
                        />
                    </Stack>

                }
            </header>
        </AppBar>
    );
};

export default Header;
